<template>
  <main class="blog-con">
    <section class="part1">
      <div class="box">
        <p class="title">Company News</p>
        <div class="c--bx">
          <div class="img-box">
            <!-- <img src="/static/images/news/01-banner.png" alt=""> -->
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" data-i="0">
                  <div class="--itm">
                    <div class="img" @click="jump2link(blog_data_lastest3[0].solink)">
                      <img :src="blog_data_lastest3[0].img" alt="">
                    </div>
                    <div class="text--bx --sm">
                      <p class="date" v-html="blog_data_lastest3[0].date">2022/01/20</p>
                      <p class="l-title" v-html="blog_data_lastest3[0].title"
                        @click="jump2link(blog_data_lastest3[0].solink)"></p>
                      <p class="text" v-html="blog_data_lastest3[0].content"
                        @click="jump2link(blog_data_lastest3[0].solink)"></p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide" data-i="1">
                  <div class="--itm">
                    <div class="img" @click="jump2link(blog_data_lastest3[1].solink)">
                      <img :src="blog_data_lastest3[1].img" alt="">
                    </div>
                    <div class="text--bx --sm">
                      <p class="date" v-html="blog_data_lastest3[1].date">2022/01/20</p>
                      <p class="l-title" v-html="blog_data_lastest3[1].title"
                        @click="jump2link(blog_data_lastest3[1].solink)"></p>
                      <p class="text" v-html="blog_data_lastest3[1].content"
                        @click="jump2link(blog_data_lastest3[1].solink)"></p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide" data-i="2">
                  <div class="--itm">
                    <div class="img" @click="jump2link(blog_data_lastest3[2].solink)">
                      <img :src="blog_data_lastest3[2].img" alt="">
                    </div>
                    <div class="text--bx --sm">
                      <p class="date" v-html="blog_data_lastest3[2].date">2022/01/20</p>
                      <p class="l-title" v-html="blog_data_lastest3[2].title"
                        @click="jump2link(blog_data_lastest3[2].solink)"></p>
                      <p class="text" v-html="blog_data_lastest3[2].content"
                        @click="jump2link(blog_data_lastest3[2].solink)"></p>
                    </div>
                  </div>
                </div>

                <!-- <div class="swiper-slide" v-for="(key,o) in blog_data_lastest3" :key="key" :data-i="key">
                                <div class="--itm">
                                    <div class="img" @click="jump2link(o.solink)">
                                        <img :src="o.img" alt="">
                                    </div>
                                    <div class="text--bx --sm">
                                        <p class="date" v-html="o.date"></p>
                                        <p class="l-title" v-html="o.title" @click="jump2link(o.solink)"></p>
                                        <p class="text" v-html="o.content" @click="jump2link(o.solink)"></p>
                                    </div>
                                </div>
                            </div> -->
              </div>
              <!-- <div class="swiper-pagination-custom --sm"></div> -->
            </div>
          </div>
          <div class="--text--bx">
            <div class="text--bx --lg">
              <p class="date" v-html="blog_data_lastest3[part1_swiper_index].date"></p>
              <p class="l-title" v-html="blog_data_lastest3[part1_swiper_index].title"
                @click="jump2link(blog_data_lastest3[part1_swiper_index].solink)"></p>
              <p class="text" v-html="blog_data_lastest3[part1_swiper_index].content"
                @click="jump2link(blog_data_lastest3[part1_swiper_index].solink)"></p>
            </div>
            <div class="swiper-pagination-custom"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="part2">
      <div class="box">
        <p class="title">Blog</p>
        <div class="list--bx">
          <a class="a-link" v-for="(o,_key) in blog_data" :key="_key" :href="o.solink? o.solink.replace('.html', ''): o.solink" target="_blank">
            <div class="item">
              <div class="img"><img :src="o.img" alt=""></div>
              <p class="date" v-html="o.date"></p>
              <p class="i-title" v-html="o.title"></p>
              <p class="text" v-html="o.content.substring(0,200)"></p>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="part2 part2-3" v-if="0">
      <div class="box">
        <p class="title">News</p>
        <div class="list--bx">
          <a class="a-link" v-for="(o,_key) in news_data" :key="_key">
            <div class="item">
              <div class="img"><img :src="o.img" alt=""></div>
              <p class="date" v-html="o.date"></p>
              <p class="i-title" v-html="o.title"></p>
              <p class="text" v-html="o.content"></p>
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="part4">
      <div class="box">
        <div class="l--bx">
          <p class="title">Contact Us</p>
        </div>
        <div class="r--bx">
          <div class="img"><img src="/static/images/news/icon_email.png" alt=""></div>
          <p class="text">For media inquiries, please email <a href="mailto:media@smartz.cloud">media@smartz.cloud</a>
          </p>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import { WOW } from "wowjs";
import Swiper from "swiper";
import jQuery from "jquery";
  export default {
    name: "blog",
    data() {
      return {
        headerElement: window.vPageHeader,
        footerElement: window.vPageFooter,
        form_data: {
          name: '',
          company: '',
          email: '',
          phone: '',
          job: '',
          units: '',
          way: '',
          message: '',
          show_flag: false,
        },
        dialog: {
          waiting: false,
          count: 30,
          timer: 0,
          text: 'Submit'
        },
        msg: 'sdsd',
        year: 2021,
        open_menu: false,
        words: {
          title: '',
          content: ''
        },
        words2: {
          title: '',
          content: ''
        },
        text_obj: [
          { title: 'Smart Thermostats', text: 'Reduce energy consumption while increasing potential market value through the use of smart thermostats.' },
          { title: 'Smart Sensors', text: 'Be alerted when your smart sensor detects movement from the opening of your door or window.' },
          { title: 'Smart Locks', text: 'Enhance the comfort and security of your tenants with smart locks.' },
          { title: 'Smart Lighting', text: 'Provide tenants with a unique color scheme for your lighting.' },
        ],
        text_obj2: [
          { cont_id: 1, title: 'Improve the Properties and Income', text: ' Tenants are becoming more technology forward and are willing to pay more for apartments that include smart devices which will increase your income.' },
          { cont_id: 2, title: 'Tenants Management', text: 'Screen tenants, create leases, auto schedule rent payments, receive and track the timeline of maintenance requests and repairs directly from our manager portal.' },
          { cont_id: 3, title: 'Maintenance Requests', text: 'Receive and track the timeline of maintenance requests and repairs directly from our manager portal.' },
          { cont_id: 4, title: 'Self Touring and Self Check-in', text: 'Have potential tenants sign up for a time and receive a limited time access code to safely and securely tour your property without you having to be there.' },
          { cont_id: 5, title: 'Environment <br>Monitoring', text: 'Access your security devices all from one platform and get notified if suspicious activity occurs.' },
        ],
        nav_list: [
          { id: 0, text_id: -1, url: '/static/images/home/inner-page/nav-workspace.png', act_url: '/static/images/home/inner-page/nav-workspace.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 1, text_id: 0, url: '/static/images/home/inner-page/nav-properties.png', act_url: '/static/images/home/inner-page/nav-properties-a.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 2, text_id: 1, url: '/static/images/home/inner-page/nav-tenants.png', act_url: '/static/images/home/inner-page/nav-tenants-a.png', content: '/static/images/home/inner-page/Tenants.png' },
          { id: 3, text_id: 2, url: '/static/images/home/inner-page/nav-maintenance.png', act_url: '/static/images/home/inner-page/nav-maintenance-a.png', content: '/static/images/home/inner-page/Maintenance.png' },
          { id: 4, text_id: 3, url: '/static/images/home/inner-page/nav-access.png', act_url: '/static/images/home/inner-page/nav-access-a.png', content: '/static/images/home/inner-page/Access.png' },
          { id: 5, text_id: 4, url: '/static/images/home/inner-page/nav-environment.png', act_url: '/static/images/home/inner-page/nav-environment-a.png', content: '/static/images/home/inner-page/Environment.png' },
          { id: 6, text_id: -1, url: '/static/images/home/inner-page/nav-financials.png', act_url: '/static/images/home/inner-page/nav-financials.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 7, text_id: -1, url: '/static/images/home/inner-page/nav-analytics.png', act_url: '/static/images/home/inner-page/nav-analytics.png', content: '/static/images/home/inner-page/Properties.png' },
          { id: 8, text_id: -1, url: '/static/images/home/inner-page/nav-community.png', act_url: '/static/images/home/inner-page/nav-community.png', content: '/static/images/home/inner-page/Properties.png' },
        ],
        current_index: 1,
        current_index_1: 0,
        auto_play_arr: [1, 2, 3, 4, 5],
        auto_play_timer: 0,
        auto_play_count: 0,
        g_conut: 0,
        mouse_evt: false,
        blog_data_lastest3: [
          {
            id: 12, date: "04/26/2022", img: "/static/images/detail/Deep.png",
            title: "Deep Dive into SaaS", solink: 'detail.html?nid=12&_t=' + (new Date().getTime()),
            "content": "SaaS or software as a service has been around since the invention of the internet but has emerged as a big player in the digital age. SaaS has benefited industries including...",
          },
          {
            id: 11, date: '04/14/2022', img: '/static/images/detail/Renting.png', link: '',
            title: 'Renting Tips for your Next Place', solink: 'detail.html?nid=11&_t=' + (new Date().getTime()),
            content: `Renting a property can be a stressful situation for people whether they are first-time renters or seasoned renters. Searching for a new place, signing a lease, and moving...`,
          },
          {
            id: 10, date: '04/04/2022', img: '/static/images/detail/Smart.png', link: '',
            title: 'Devices in the Smart Home of your Dreams', solink: 'detail.html?nid=10&_t=' + (new Date().getTime()),
            content: `The digital age has allowed us to better our lives in ways previously not thought possible. One of those ways is through smart devices, which have enabled us to connect different...`,
          },
        ],
        part1_swiper_index: 0,
        blog_data: [
          {
            id: 1, date: '10/13/2021', img: '/static/images/news/02-5.png', link: 'https://www.linkedin.com/pulse/interview-property-manager-tech-apartments-smartz-inc',
            title: 'All that you need to know about the PropTech Industry', solink: 'detail.html?nid=1&_t=' + (new Date().getTime()),
            content: 'There is over 36 Trillion dollars in the US Housing Market. The market has grown exponentially over the past 10 years and is continuing to grow...',
          },
          {
            id: 2, date: '10/29/2021', img: '/static/images/news/02-4.png', link: 'https://www.linkedin.com/feed/update/urn:li:activity:6883783542103404544',
            title: 'Smart Home Amenities Expected by Gen Z', solink: 'detail.html?nid=2&_t=' + (new Date().getTime()),
            content: 'As someone who is a part of the Gen Z generation, I can remember a time before smart home devices when we had movies like Smart House. Which...',
          },
          {
            id: 3, date: '12/02/2021', img: '/static/images/news/02-3.png', link: 'https://www.linkedin.com/feed/update/urn:li:activity:6872272157787914240',
            title: 'Smart Home Ecosystems for Apartments', solink: 'detail.html?nid=3&_t=' + (new Date().getTime()),
            content: 'Smart devices have taken over the technology industry. There are smart lights, smart locks, smart cameras, smart blinds, and even smart toasters...',
          },
          {
            id: 4, date: '01/03/2022', img: '/static/images/news/02-2.png', link: 'https://www.linkedin.com/feed/update/urn:li:activity:6859852392343646208',
            title: 'Why is Champaign-Urbana great for Tech?', solink: 'detail.html?nid=4&_t=' + (new Date().getTime()),
            content: 'Wolfram Alpha, Yahoo, and Caterpillar all have one thing in common. They all have roots in a midsize central Illinois town. Many people think...',
          },
          {
            id: 5, date: '01/14/2022', img: '/static/images/news/02-1.png', link: 'https://www.linkedin.com/feed/update/urn:li:activity:6854074367618420736',
            title: 'Interview with a Property Manager about Tech in Apartments', solink: 'detail.html?nid=5&_t=' + (new Date().getTime()),
            content: 'They say that growth and learning never stops. Over the holidays, I discovered that this is true first hand. In Smartz’s effort to continuously improve...',
          },
          {
            id: 6, date: '01/31/2022', img: '/static/images/news/02-20220216.png', link: 'https://www.linkedin.com/posts/smartz-inc_smarthome-proptech-smartdevices-activity-6893921647032639489-WmxF',
            title: '4 Reasons to Make your Home Smart', solink: 'detail.html?nid=6&_t=' + (new Date().getTime()),
            content: `There are several pros to making your space smart by using smart devices. Let's dive into what I consider to be the top 4 pros of integrating smart...`,
          },
          {
            id: 7, date: '02/22/2022', img: '/static/images/detail/news/07.png', link: 'https://www.linkedin.com/posts/smartz-inc_smarthome-proptech-smartdevices-activity-6893921647032639489-WmxF',
            title: 'Happier Tenants = Better Retention', solink: 'detail.html?nid=7&_t=' + (new Date().getTime()),
            content: `Property Managers are responsible for overseeing all aspects of the properties that they are in charge of from maintenance requests, to marketing...`,
          },
        ],
        news_data: [

        ],
        version_number: `1.0.${parseInt((new Date().getTime()) / (1000 * 60 * 30))}`
      }
    },
    mounted() {
      new WOW().init();
      this.menuOpt();

      this.dynamicLoad();

      // this.blog_data = news_list.reverse();
      // this.blog_data_lastest3 = [news_list[0], news_list[1], news_list[2]]
      // // this.blog_data_lastest3 = this.blog_data;
      // this.swiperFunc();

      var _self = this;
      // _self.resize();
      window.onresize = function () {
        // _self.resize();
      }

      this.year = (new Date()).getFullYear();
    },
    methods: {
      submitFormData() {
        var form_data = this.form_data;
        console.log(form_data);
        var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        var isOk = (form_data.email).trim() != '' &&
          (form_data.name).trim() != '' &&
          (form_data.company).trim() != '' &&
          (form_data.phone).trim() != '' &&
          (form_data.job).trim() != '';
        if (isOk) {
          if (!reg.test(form_data.email)) {
            alert('Email address is invalid');
            return;
          }
          var data = {
            name: form_data.name,
            company: form_data.company,
            email: form_data.email,
            phone: form_data.phone,
            job: form_data.job,
            units: form_data.units,
            way: form_data.way,
            message: form_data.message,
          }
          var _self = this;
          _self.dialog.waiting = true;
          _self.dialog.count = 30;
          _self.dialog.text = 'Submit (' + _self.dialog.count + ')';
          _self.dialog.timer = setInterval(function () {
            _self.dialog.count = _self.dialog.count - 1;
            _self.dialog.text = 'Submit (' + _self.dialog.count + ')';
            if (_self.dialog.count == 0) {
              _self.dialog.waiting = false;
              _self.dialog.text = 'Submit';
              clearInterval(_self.dialog.timer);
            }
          }, 1000);
          // jQuery.post('http://127.0.0.1:7001/api/contact/demo', data, function(res){
          jQuery.post('/api/contact/demo', data, function (res) {
            if (res.result == 'ok') {
              alert('Sent successfully');
              setTimeout(function () {
                _self.dialog.waiting = false
                _self.dialog.text = 'Submit';
                clearInterval(_self.dialog.timer);
              }, 500)
            } else {
              alert('Send failure');
              setTimeout(function () {
                _self.dialog.waiting = false
                _self.dialog.text = 'Submit';
                clearInterval(_self.dialog.timer);
              }, 500)
            }
          })

        } else {
          alert('The required information cannot be empty');
        }

      },
      toCloseDialog(n) {
        this.form_data.show_flag = 1 == n
      },
      openMenu() {
        this.open_menu = !this.open_menu;
        if (this.open_menu) {
          jQuery('.box--menu').slideToggle();
        } else {
          jQuery('.box--menu').slideToggle();
        }
      },

      menuOpt() {
        jQuery('.logo--nav .n-item').hover(function () {
          jQuery(this).find('.list-menu').stop().slideDown();
        },
          function () {
            jQuery(this).find('.list-menu').stop().slideUp();
          })
      },
      swiperFunc() {
        var _self = this;
        var mySwiper = new Swiper('.part1 .swiper-container', {
          autoplay: 3000,//可选选项，自动滑动
          // onlyExternal : true,
          speed: 1000,
          loop: true,
          paginationClickable: true,
          onInit: function (swiper) {
            var i = jQuery('.part1 .swiper-container .swiper-slide-active').attr('data-i');
            _self.part1_swiper_index = i;
          },
          onSlideChangeStart: function (swiper) {
            var i = jQuery('.part1 .swiper-container .swiper-slide-active').attr('data-i');
            _self.part1_swiper_index = i;
            // new WOW().init();
          },
          pagination: '.part1 .swiper-pagination-custom',
          paginationCustomRender: function (swiper, current, total) {
            var str = ``;
            for (let i = 0; i < total; i++) {
              str = str + `<span></span>`;
            }
          },
        })

        // mySwiper.slideNext();
      },
      jump2link(url) {
        if (url == '') return;
        window.open(url);
      },
      dynamicLoad() {
        var _self = this;
        var _doc = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', './data/news.js');
        _doc.appendChild(script);
        script.onload = script.onreadystatechange = function () {
          if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
            // _self.getData(news_list);
            // _self.blog_data = news_list.reverse();

            fetch('https://www.smartz.cloud/webapi/getBlogs').then(res => res.json())
              .then(res => {
                let arr = res.reverse();
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i] && arr[i].img === 'image-170473313557020944113-min.jpg') {
                    arr[i].img = "https://www.smartz.cloud/webapi/getImage/" + arr[i].img;
                  }
                  if(arr[i] && arr[i].img && arr[i].img.substring(0,2) === './') {
                    arr[i].img = "/static/" + arr[i].img.substring(2)
                  }
                }
                _self.blog_data = arr
              })

            // _self.blog_data = blogData.reverse()

            // _self.blog_data_lastest3 = [news_list[0], news_list[1], news_list[2]]
            // this.blog_data_lastest3 = this.blog_data;
            _self.swiperFunc();

          }
          script.onload = script.onreadystatechange = null;
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>


// WEBPACK FOOTER //
// src/views/blog/index.vue